export default __webpack_public_path__ + "static/media/red.7936feda.png";